export const log = (action) => {
  const { payload } = action

  const type = payload.from.action ? payload.from.action.type : payload.from.type
  console.error(`EXCEPTION from ${type} :`, payload.message, payload) // eslint-disable-line no-console
}
